// extracted by mini-css-extract-plugin
export default {"modal-overlay":"Modal_modal-overlay__e+E4a","modal-header":"Modal_modal-header__VnYCp","modal-overlay-backdrop":"Modal_modal-overlay-backdrop__We8jb","modal":"Modal_modal__yEgVW"};